window.global = window;

export {};
